export default __webpack_public_path__ + "static/media/InactiveCamera.f0f631cc.svg";